<template>
  <v-app class="custom_bg">
    <v-container>
      <v-row>
        <v-col cols="12" md="12">
          <v-card>
            <v-card-title class="pb-0">
              <v-menu offset-y :close-on-content-click="false">
                <template v-slot:activator="{ on, attrs }">
                  <span class="icon-text">
                    filter by staff
                    <v-btn icon v-bind="attrs" v-on="on">
                      <v-icon small :color="staff ? 'primary' : ''">
                        mdi-filter
                      </v-icon>
                    </v-btn>
                  </span>
                </template>
                <div
                  style="background-color: white; width: 300px; padding: 10px"
                >
                  <v-select
                    color
                    v-model="staff"
                    dense
                    outlined
                    :items="staffItem"
                    item-text="name"
                    item-value="name"
                    label="select staff name"
                  ></v-select>

                  <v-btn @click="staff = ''" small text color="primary"
                    >Clean</v-btn
                  >
                </div>
              </v-menu>
              <v-menu offset-y :close-on-content-click="false">
                <template v-slot:activator="{ on, attrs }">
                  <span class="icon-text">
                    filter by status
                    <v-btn icon v-bind="attrs" v-on="on">
                      <v-icon small :color="staff ? 'primary' : ''">
                        mdi-filter
                      </v-icon>
                    </v-btn>
                  </span>
                </template>
                <div
                  style="background-color: white; width: 300px; padding: 10px"
                >
                  <v-select
                    color
                    v-model="status"
                    dense
                    outlined
                    :items="statusItem"
                    item-text="name"
                    item-value="name"
                    label="select status"
                  ></v-select>

                  <v-btn @click="status = ''" small text color="primary"
                    >Clean</v-btn
                  >
                </div>
              </v-menu>
              <!-- <v-btn color="secondary" class="text-capitalize" @click="credit()"
                >Credit</v-btn
              >
              <v-btn
                color="success"
                class="text-capitalize mx-4"
                @click="completed()"
                >Completed</v-btn
              > -->
              <v-spacer></v-spacer>
              <v-spacer></v-spacer>
              <v-text-field
                v-model="search"
                outlined
                dense
                append-icon="mdi-magnify"
                label="Search all transactions"
              ></v-text-field>
            </v-card-title>
            <v-data-table
              :headers="headers"
              :items="filteredSales"
              loading-text="fetching sales"
              :loading="loading3"
              :search="search"
            >
              <template v-slot:top>
                <v-dialog v-model="dialog" max-width="500px">
                  <v-card>
                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="12" md="12">
                            <div class="text-center">
                              <p class="title">{{ formTitle }}</p>

                              <p>
                                Total Amount Payable
                                <strong>{{ editedItem.total_amount }}</strong>
                              </p>
                              <p>
                                Outstanding Payment
                                <strong>{{ sub }}.00</strong>
                              </p>
                              <div>
                                <v-text-field
                                  outlined
                                  dense
                                  :max="sub"
                                  type="number"
                                  oninput="if(Number(this.value) > Number(this.max)) this.value = this.max;"
                                  v-model="newPayment"
                                  label="Make Payment"
                                ></v-text-field>
                              </div>
                              <p>
                                New Balance
                                <strong>{{ sub - newPayment }}.00</strong>
                              </p>
                            </div>
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" text @click="close">
                        Cancel
                      </v-btn>
                      <v-btn
                        color="primary"
                        text
                        @click="save(editedItem)"
                        :loading="loading2"
                      >
                        update
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <template v-slot:[`item.action`]="{ item }">
                <v-btn
                  color="primary"
                  small
                  class="mx-2 text-capitalize"
                  width="55"
                  :to="/receipt/ + item.id"
                  >View</v-btn
                >
                
                <v-btn
                  v-if="
                    JSON.parse(item.total_amount) > JSON.parse(item.amount_paid)
                  "
                  color="primary"
                  small
                  text
                  class=" my-2 text-capitalize"
                  @click="editItem(item)"
                  >Update payment</v-btn
                >
              </template>
              <template v-slot:no-data>
                <span>No data available</span>
              </template>

              <template v-slot:[`item.customer`]="{ item }">
                <span>{{ item.customer }}</span>

                <div v-if="item.customer == undefined">
                  <span> Guest </span>
                </div>
              </template>
              <template v-slot:[`item.created_at`]="{ item }">
                <span>{{
                  new Date(item.created_at).toLocaleDateString()
                }}</span>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  data: () => ({
    dialog: false,
    search: "",
    loading1: false,
    loading2: false,
    loading: true,
    newPayment: 0,
    sales: [],
    delItem: {},
    items: ["goods", "services"],
    dialogDelete: false,
    headers: [
      {
        text: "Customer Name",
        align: "start",
        sortable: false,
        value: "customer",
      },
      { text: "Transaction ID", value: "order_id", sortable: false },
      { text: "Transaction Date", value: "created_at", sortable: false },
      { text: "Actions", value: "action", sortable: false },
    ],
    product: [],
    editedIndex: -1,
    loading3: false,
    editedItem: {
      name: "",
      type: "",
      price: "",
      stock: "",
    },
    staffItem: [],
    statusItem: ["credit", "completed"],
    staff: "",
    status: "",
    cr: null,
  }),
  computed: {
    sub() {
      return this.editedItem.total_amount - this.editedItem.amount_paid;
    },
    formTitle() {
      return this.editedIndex === -1 ? "Update Payment" : "Update Payment";
    },
    ...mapGetters(["getUser", "currentUser"]),
    filteredSales() {
      let conditions = [];
      if (this.status) {
        conditions.push(this.filterStatus);
      }
      if (this.staff) {
        conditions.push(this.filterStaff);
      }
      if (conditions.length > 0) {
        return this.sales.filter((pr) => {
          return conditions.every((condition) => {
            return condition(pr);
          });
        });
      }
      return this.sales;
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },
  mounted() {
    this.fetchSales();
    this.fetchStaffs();
  },
  methods: {
    filterStaff(item) {
      return item.staff.toLowerCase().includes(this.staff.toLowerCase());
    },
    filterStatus(item) {
      return item.ss.toLowerCase().includes(this.status.toLowerCase());
    },
    fetchSales() {
      this.loading3 = true;
      fetch(
        "https://receipt.drecsoft.com/api/v1/sales/sales?pagination=false",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.currentUser}`,
          },
        }
      )
        .then((response) => response.json())
        .then((response) => {
          let doc = response.data.sales.data;
          console.log(doc);
          doc.forEach((element) => {
            if (
              JSON.parse(element.total_amount) > JSON.parse(element.amount_paid)
            ) {
              this.cr = "credit";
            } else {
              this.cr = "completed";
            }
            let data = {
              amount_paid: element.amount_paid,
              created_at: element.created_at,
              customer: element.customer?.name,
              discount: element.discount,
              expected_date: element.expected_date,
              id: element.id,
              cus: element.customer?.cid,
              order_id: element.order_id,
              payment_method: element.payment_method,
              staff: element.staff?.name,
              status: element.status,
              store_id: element.store_id,
              total_amount: element.total_amount,
              updated_at: element.updated_at,
              user_id: element.user_id,
              products: [],
              ss: this.cr,
            };
            this.sales.push(data);
            console.log(data);
          });
          this.loading3 = false;
        })
        .catch((err) => {
          this.loading3 = false;
          console.log(err);
        });
    },
    editItem(item) {
      this.editedIndex = this.sales.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      });
    },
    save(item) {
      this.loading2 = true;
      let total = JSON.parse(this.newPayment) + JSON.parse(item.amount_paid);
      const dt = {
        amount_paid: JSON.stringify(total),
        created_at: item.created_at,
        customer: item.cus,
        discount: item.discount,
        expected_date: item.expected_date,
        id: item.id,
        order_id: item.order_id,
        payment_method: item.payment_method,
        staff: item.staff,
        status: item.status,
        store_id: item.store_id,
        total_amount: item.total_amount,
        updated_at: item.updated_at,
        user_id: item.user_id,
        products: item.products,
      };

      if (this.editedIndex > -1) {
        Object.assign(this.sales[this.editedIndex], this.editedItem);
        console.log(dt);
        fetch("https://receipt.drecsoft.com/api/v1/sales/update-sale", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${this.currentUser}`,
          },
          body: JSON.stringify(dt),
        })
          .then((res) => res.json())
          .then((response) => {
            this.loading2 = false;
            console.log("updated successfuly", response);
            this.close();
            this.$router.go();
          })
          .catch((err) => {
            this.loading2 = false;
            console.log(err);
            this.close();
          });
      }
    },
    fetchStaffs() {
      fetch("https://receipt.drecsoft.com/api/v1/business/all-staff", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${this.currentUser}`,
        },
      })
        .then((response) => response.json())
        .then((response) => {
          this.staffItem = response.staffs;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style scoped>
.custom_bg {
  background: #f6f7ff;
}
</style>
